import React from 'react';
import { getYearFilterManagee } from './helpers/yearManagees';
import YearFilterOperationSelector from './YearFilterOperationSelector';

type Props = {
    filter: SentenceFilterT;
    setFilter: (fields: Partial<SentenceFilterT>) => void;
    isPerimeterFilter: boolean;
    isDisabled: boolean;
    shouldDebounce?: boolean;
    inputProps?: object;
};

const YearFilterManager = ({
    filter,
    setFilter,
    isPerimeterFilter,
    isDisabled,
    shouldDebounce,
    inputProps,
}: Props) => {
    const YearFilterPickerItem = getYearFilterManagee(filter);

    return (
        <YearFilterPickerItem
            filter={filter}
            isPerimeterFilter={isPerimeterFilter}
            shouldDebounce={shouldDebounce}
            inputProps={inputProps}
            setFilter={setFilter}
        >
            <YearFilterOperationSelector
                filter={filter}
                isDisabled={!!isDisabled}
                setFilter={setFilter}
                isPerimeterFilter={isPerimeterFilter}
            />
        </YearFilterPickerItem>
    );
};

export default React.memo(YearFilterManager);
